import DataRoomSelectedDocumentsProvider from './DataRoomSelectedDocuments.provider';

export default DataRoomSelectedDocumentsProvider;
